<template>
    <el-dialog custom-class="dialogForm" class="measDialog" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" :title="title+'课程'">
        <el-scrollbar class="dialogContentScroll">
            <el-form :model="form" ref="form" :rules="rules">
                <div class="formItemBox mb-15">
                    <el-form-item label="课程名称" prop="courseconfigname">
                        <el-select :disabled="disabled" v-model="form.name" @change="getClassCOde" placeholder="请选择">
                                <el-option
                                v-for="item in options"
                                :key="item.code"
                                :label="item.name"
                                :value="item.name">
                                </el-option>
                            </el-select>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="学分数" prop="score">
                        <el-input v-model="form.score" maxlength="20" show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="课时数" prop="periodcount">
                        <el-input v-model="form.periodcount" maxlength="20" show-word-limit placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="授课开始时间" prop="begindate">
                        <el-date-picker
                            value-format="yyyy-MM-dd"
                            v-model="form.begindate"
                            type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="授课结束时间" prop="enddate">
                        <el-date-picker
                            value-format="yyyy-MM-dd"
                            v-model="form.enddate"
                            type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="说明" prop="memo">
                        <el-input v-model="form.memo" maxlength="100" type="textarea" placeholder="请输入课程简介"></el-input>
                    </el-form-item>
                </div>
            </el-form>
        </el-scrollbar>
        <div slot="footer" style="text-align:right">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" :loading="isLoading" @click="saveClass('form')">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import {getCourseListBySelect,saveCourse, getCourseDetails} from '@/api/measApi/teachManagement.js'
import {getTableDefaultPageSize} from '@/assets/measAssets/js/tools.js'
export default {
    data(){
        return {
            defaultForm: {},
            form: {
                begindate: '',
                enddate: '',
                classcode: '',
                code: '',
                courseconfigcode: '',
                courseconfigname: '',
                memo: '',
                name: '',
                periodcount: '',
                score: ''
            },
            disabled: false,
            xlParamse: {
                condition: {
                    catecode: '',
                    catename: '',
                    classcode: '',
                    classname: '',
                    name: '',
                    status: ''
                },
                orderbyname: '',
                orderbyorder: '',
                page: 1,
                pagesize: getTableDefaultPageSize()
            },
            options: [

            ],
            rules: {
                courseconfigname: [
                    { required: true, message: '课程名称', trigger: 'blur' }
                ],
                score: [
                    { required: true, message: '学分数', trigger: 'blur' }
                ],
                periodcount: [
                    { required: true, message: '课时数', trigger: 'blur' }
                ],
                begindate: [
                    { required: true, message: '授课开始时间', trigger: 'blur' }
                ],
                enddate: [
                    { required: true, message: '授课结束时间', trigger: 'blur' }
                ]
            },
            visible: false,
            title: '',
            isLoading: false,
            detailParams: {
                code: ''
            }
        }
    },
    methods: {
        init(code){
            this.defaultForm = JSON.parse(JSON.stringify(this.form))

            this.title = code?"编辑": '新增'
            this.form.code = code || ''
            this.detailParams.code = code || ''
            this.visible = true
            this.form.classcode = this.$route.query.code
            this.getClassName()
            if(code){
                this.disabled = true
                this.getCourseDetails()
            }
            console.log(this.$route.query.code,'this.$route.query.codethis.$route.query.code')
        },
        // 获取已存在的课程名称
        getClassName(){
            getCourseListBySelect(this.xlParamse).then(res => {
                this.options = res.data
            })
        },
        handleClose(){
            this.visible = false
            this.isLoading = false
            this.form = JSON.parse(JSON.stringify(this.defaultForm))
            this.disabled = false
            this.$refs.form.clearValidate()
        },
        getClassCOde(name){
            this.options.map(item => {
                if(item.name === name){
                    this.form.courseconfigcode = item.code
                    this.form.courseconfigname = item.name
                    return true
                }
            })
            console.log(this.form)
        },
        // 获取课程详情
        getCourseDetails(){
            getCourseDetails(this.detailParams).then(res => {
                // this.form = res.data
                // this.form.classcode = this.$route.query.code
                this.form.begindate = res.data.begindate
                this.form.enddate = res.data.enddate
                this.form.courseconfigcode = res.data.courseconfigcode
                this.form.courseconfigname = res.data.courseconfigname
                this.form.memo = res.data.memo
                this.form.name = res.data.name
                this.form.periodcount = res.data.periodcount
                this.form.score = res.data.score
                this.form.code = res.data.code


                console.log(res,'详情')
            })
        },
        saveClass(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isLoading = true
                    this.saveCourse()
                } else {
                    return false;
                }
            });
        },
        saveCourse(){
            saveCourse(this.form).then(res => {
                this.isLoading = false
               if(res.code == '000'){
                  this.$message.success(res.msg)
                  this.visible = false
                  this.$parent.getCourseList()
               }else{
                    this.$message.error(res.msg)
               }
            })
        }
    }
}
</script>